export const FileRender = ({ message }) => {
  const files = message.files || [message];

  const openFile = (file) => {
    const fileSource = file.base64 || file.url;
    if (!fileSource) return;

    const ext = file.fileName?.split('.').pop()?.toLowerCase();

    if (ext === 'pdf') {
      window.open(fileSource, '_blank', 'noopener,noreferrer');
      return;
    }

    const link = document.createElement('a');
    link.href = fileSource;
    link.download = file.fileName || 'downloaded-file';
    link.target = '_blank';
    link.rel = 'noopener noreferrer';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const openAll = () => {
    files.forEach((file) => openFile(file));
  };

  return (
    <>
      {files.length > 0 && <div className="file-download-link" onClick={openAll}></div>}
      {files.map((file, idx) => {
        const ext = file.fileName?.split('.').pop()?.toUpperCase() || 'FILE';

        return (
          <div
            key={idx}
            className={`file-wrapper file-${ext.toLowerCase()} clickable`}
            onClick={() => openFile(file)}
          >
            <div className="file-info">
              <div className="file-name">{file.fileName}</div>
              <div className="file-creds">
                <span className="file-ext">{ext}</span>
                <span>Document</span>
                <span className="file-separator"></span>
                <span className="file-size">{file.size}</span>
                <span>MB</span>
              </div>
            </div>
            <div className="file-icon"></div>
          </div>
        );
      })}
    </>
  );
};
